import { useMemo } from 'react'
import { Pressable, Text, View } from 'react-native'
import { LogOut } from 'lucide-react-native'
import { useTheme } from '../../../src/theme/useTheme'
import { useThemeContext } from '../../../src/theme/ThemeContext'
import { getLandingSignedInControlsStyles } from './LandingSignedInControls.styles'

interface LandingSignedInControlsProps {
  accountInitial: string
  accountLabel: string
  signedInAsLabel: string
  signOutLabel: string
  onPressSignOut: () => void
}

export function LandingSignedInControls({
  accountInitial,
  accountLabel,
  signedInAsLabel,
  signOutLabel,
  onPressSignOut,
}: LandingSignedInControlsProps) {
  const theme = useTheme()
  const { isDark } = useThemeContext()
  const styles = useMemo(
    () => getLandingSignedInControlsStyles(theme, isDark),
    [theme, isDark],
  )

  return (
    <View style={styles.accountControl}>
      <View style={styles.accountPill}>
        <View style={styles.accountAvatar}>
          <Text style={styles.accountAvatarText}>{accountInitial}</Text>
        </View>
        <View style={styles.accountCopy}>
          <Text style={styles.accountKicker}>{signedInAsLabel}</Text>
          <Text style={styles.accountName} numberOfLines={1}>
            {accountLabel}
          </Text>
        </View>
      </View>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={signOutLabel}
        onPress={onPressSignOut}
        style={({ hovered }) => [styles.signOutBtn, hovered && styles.signOutBtnHovered]}
      >
        <LogOut size={15} color={theme.primaryDark} />
      </Pressable>
    </View>
  )
}
